<template>
  <div
    class="modal fade"
    id="deleteModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    ref="deleteModal"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header justify-content-center">
          <h5 class="modal-title">
            <i class=""></i>
            <i class="bi bi-exclamation-circle-fill text-warning"></i>
            刪除{{ name }}
          </h5>
        </div>
        <div class="modal-body text-center">
          <p class="mb-0">
            <span v-if="!undo" class="d-block">注意！刪除後將無法復原</span>
            是否刪除 <span v-if="deleteItem">【{{ deleteItem }}】</span>{{ name }} ?
          </p>
        </div>
        <div class="modal-footer justify-content-between">
          <button
            type="button"
            class="btn btn-light border"
            data-bs-dismiss="modal"
          >
            取消
          </button>
          <button
            @click="confirmDelete"
            type="button"
            class="btn btn-warning text-light"
          >
            確認
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'DeleteModal',
  props: ['name', 'deleteItem', 'undo'],
  data () {
    return {
      bootstrap_modal: null
    }
  },
  computed: {
    ...mapState(['isShowDeleteModal'])
  },
  watch: {
    isShowDeleteModal (showState) {
      const vm = this
      if (vm.bootstrap_modal) {
        showState ? vm.bootstrap_modal.show() : vm.bootstrap_modal.hide()
      }
    }
  },
  methods: {
    ...mapMutations(['ToggleDeleteModal']),
    confirmDelete () {
      const vm = this
      vm.$emit('confirmDelete')
    }
  },
  mounted () {
    const vm = this
    const deleteModalEl = vm.$refs.deleteModal
    vm.bootstrap_modal = new Modal(deleteModalEl)

    deleteModalEl.addEventListener('hidden.bs.modal', () => {
      vm.ToggleDeleteModal(false)
    })
  }
}
</script>

<style lang="scss" scoped>
.modal-header,
.modal-footer {
  background-color: lighten($warning, 44%);
}
</style>
